
import React, { useState } from 'react';
import { Avatar, Button, Grid, Paper, TextField, Typography } from '@material-ui/core';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import EmailIcon from '@mui/icons-material/Email';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { useNavigate } from 'react-router-dom';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    if (email === 'operations@phyfarm.com' && password === 'phyfarm321') {
      navigate('/environment');
    } else {
      alert('Invalid email or password');
      setEmail('');
      setPassword('');
    }
  };

  const paperStyle = { padding: 20, height: '40vh', width: 300, margin: '150px auto' };
  const avatarStyle = { backgroundColor: '#3f51b5' };
  const headingStyle = { marginBottom: 20 };

  return (
    <Grid>
      <Paper elevation={10} style={paperStyle}>
        <Grid align='center'>
          <Avatar style={avatarStyle}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography variant='h5' style={{ headingStyle, marginTop: 10 }}>
            Phyfarm Ops CMS
          </Typography>
        </Grid>
        <TextField
          value={email}
          variant='outlined'
          placeholder='johndoe@gmail.com'
          onChange={(event) => setEmail(event.target.value)}
          fullWidth
          style={{ marginTop: 12 }}
          InputProps={{
            startAdornment: (
              <EmailIcon style={{ marginRight: 8, color: 'gray' }} />
            ),
          }}
        />
        <TextField
          value={password}
          type='password'
          variant='outlined'
          placeholder='password'
          onChange={(event) => setPassword(event.target.value)}
          style={{ marginTop: 10 }}
          fullWidth
          InputProps={{
            startAdornment: (
              <VpnKeyIcon style={{ marginRight: 8, color: 'gray' }} />
            ),
          }}
        />
        <Button
          style={{ marginTop: 32 }}
          type='submit'
          color='primary'
          variant='contained'
          fullWidth
          onClick={handleSubmit}
          startIcon={<LockOutlinedIcon />}
        >
          Login
        </Button>
      </Paper>
    </Grid>
  );
};
